import React from 'react'
import { useTimer } from 'hooks'

export const NotExported = () => {
  const close = () => document.getElementById('dwNotExported')?.remove()
  const seconds =
    useTimer(20, () => {
      window.CCP_CONF && close()
    }) - 5

  return (
    <>
      <a onClick={close}>&times;</a>
      <strong>CCP_CONF missing</strong>
      <p>(user "{window.store?.getState().myProfile.email}" not exported to CED)</p>
      <div>Refetching {seconds > 0 ? `in ${seconds}s` : seconds >= -5 ? '...' : 'failed'}</div>
    </>
  )
}

export default NotExported
